<script>
export default {
  props: {
    currentQuestion: Object,
  },

  data() {
    return {
      BACKEND_URL: process.env.VUE_APP_BACKEND_URL,
      BACKEND_URL_VERSION: process.env.VUE_APP_BACKEND_URL_VERSION,
      selectedOption: null,
    };
  },
};
</script>

<template>
  <div v-if="currentQuestion" class="mym-question-body">
    <div class="mym-question-navigation">
      <div class="mym-qn-header">
        <div class="mym-question-number">
          <strong>Petunjuk Benar Salah</strong>
        </div>
      </div>

      <div class="mym-question-section">
        <p>Silahkan pilih salah satu jawaban dengan klik pada pilihan jawaban yang tersedia.</p>
        <p>Klik "preview" untuk menampilkan gambar</p>

        <div class="mb-3">
          <b>Contoh Soal</b>

          <!-- Studi Kasus -->
          <div class="mym-card-case mt-2 mb-3" v-if="currentQuestion?.soal_text">
            <div class="mym-card-jumbotron-header">
              <div class="mym-card-jumbotron-icon text-light">
                <i class="fa fa-file-alt"></i>
              </div>
              <h3 class="mym-card-jumbotron-title">Studi Kasus</h3>
            </div>
            <div class="mym-card-jumbotron-content">
              {{ currentQuestion?.soal_text }}
            </div>
          </div>

          <!-- Gambar soal -->
          <img
            v-if="currentQuestion?.soal_image"
            :src="BACKEND_URL + currentQuestion?.soal_image"
            class="mym-question-image mb-3"
          />

          <!-- Pertanyaan -->
          <div class="mym-question-text">
            {{ currentQuestion?.pertanyaan }}
          </div>
        </div>
      </div>
    </div>

    <!-- OPTIONS SECTION -->
    <div class="mym-options-section">
      <div class="mym-options boolean-mode">
        <!-- BENAR - selalu kiri -->
        <div
          class="mym-option-card boolean-card"
          :class="{ active: selectedOption === 'benar' }"
          @click="selectedOption = 'benar'"
        >
          <div class="boolean-content">
            <div class="boolean-icon">
              <span :class="selectedOption === 'benar' ? 'text-primary' : ''" class="icon-i">
                <i class="fa fa-check fa-fw"></i>
              </span>
            </div>
            <div class="boolean-text">Benar</div>
          </div>
        </div>

        <!-- SALAH - selalu kanan -->
        <div
          class="mym-option-card boolean-card boolean-danger"
          :class="{ 'text-danger': selectedOption === 'salah' }"
          @click="selectedOption = 'salah'"
        >
          <div class="boolean-content">
            <div class="boolean-icon">
              <span :class="selectedOption === 'salah' ? 'text-danger' : ''" class="icon-i">
                <i class="fa fa-times fa-fw"></i>
              </span>
            </div>
            <div class="boolean-text">Salah</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
